import { useState } from "react";
import Header from "../../comps/Header";
import Footer from "../../comps/Footer";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from "../../config/Base_Url_Config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const SignUp = () => {
      const navigate = useNavigate();
      const [showPassword, setShowPassword] = useState(false);
      const [termsChecked, setTermsChecked] = useState(false);
      const [agreementChecked, setAgreementChecked] = useState(false);
      const [showConfirmPassword, setShowConfirmPassword] = useState(false);
      const [formData, setFormData] = useState({
            name: "",
            email: "",
            password: "",
            password_confirmation: "",
            term:"",
            agreement:""
      });

      const [loading, setLoading] = useState(false);
      const [error, setError] = useState("");
      const [success, setSuccess] = useState("");

      // Handle input change
      const handleChange = (e) => {
            const { name, value } = e.target;
            setFormData({
                  ...formData,
                  [name]: value
            });
      };

      // Handle form submission
      const handleSubmit = async (e) => {
            e.preventDefault();
            setLoading(true);
            setError("");
            setSuccess("");

            if (formData.password !== formData.password_confirmation) {
                  setError("Passwords do not match!");
                  setLoading(false);
                  return;
            }
            if (formData.password.length < 8) {
                  setError("The password field must be at least 8 characters.")
                  setLoading(false);
                  return;
            }

            // Create FormData object
            const formDataToSend = new FormData();
            formDataToSend.append("name", formData.name);
            formDataToSend.append("email", formData.email);
            formDataToSend.append("password", formData.password);
            formDataToSend.append("password_confirmation", formData.password_confirmation);
            formDataToSend.append("term", formData.term);
            formDataToSend.append("agreement", formData.agreement);

            try {
                  const response = await fetch(`${API_BASE_URL}/web-user-register`, {
                        method: "POST",
                        body: formDataToSend, // Send FormData instead of JSON
                  });
                  const result = await response.json();
                  // if(result?.email[0]){
                  //       setError("The email has already been taken")
                  // }
                  if (result.token) {
                        localStorage.setItem("token", result?.token)
                        localStorage.setItem("user", JSON.stringify(result?.user))
                        setSuccess("Signup successful! Redirecting...");
                        localStorage.setItem("is_user_active", true)
                        setFormData({ name: "", email: "", password: "", password_confirmation: "" });
                        toast.success("Register Successful !")
                        navigate("/home");
                  }
                   else {
                        setError(result.message || "The email has already been taken");
                  }
            } catch (error) {
                  setError("Something went wrong. Please try again.");
            } finally {
                  setLoading(false);
            }
      };

      const handleCheckboxChange = (type, checked) => {
            if (type === "terms") {
            setTermsChecked(checked);
            } else if (type === "agreement") {
            setAgreementChecked(checked);
            }

            // Validation
            if (!checked || (!termsChecked && type === "agreement") || (!agreementChecked && type === "terms")) {
            setError("Please accept both the Terms & Policies and the Passport Account Agreement.");
            } else {
            setError(null);
            }
      };


      return (
            <>
                  <Header />
                  {/* <-------- ToastContainer ------------> */}
                  <ToastContainer style={{ marginTop: "120px" }} />
                  <section className="relative py-10 md:py-24">
                        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-transparent"></div>
                        <div className="mx-auto max-w-7xl px-6 lg:px-8 relative">
                              <div className="flex flex-col items-center justify-center">
                                    <div className="w-full bg-white rounded-lg shadow-lg sm:max-w-md">
                                          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                                                <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
                                                      Sign Up to your account
                                                </h1>

                                                {/* {error && <div className="text-red-500 text-sm font-medium">{error}</div>} */}
                                                {success && <div className="text-green-500 text-sm font-medium">{success}</div>}

                                                <form className="space-y-4" onSubmit={handleSubmit}>
                                                      {/* Name Field */}
                                                      <div>
                                                            <label className="block mb-2 text-sm font-medium text-gray-900">
                                                                  Your Name
                                                            </label>
                                                            <input
                                                                  type="text"
                                                                  name="name"
                                                                  className="border border-gray-200 text-gray-900 rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full py-2 px-4"
                                                                  placeholder="Your full name"
                                                                  required
                                                                  value={formData.name}
                                                                  onChange={handleChange}
                                                            />
                                                      </div>

                                                      {/* Email Field */}
                                                      <div>
                                                            <label className="block mb-2 text-sm font-medium text-gray-900">
                                                                  Your Email ID
                                                            </label>
                                                            <input
                                                                  type="email"
                                                                  name="email"
                                                                  className="border border-gray-200 text-gray-900 rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full py-2 px-4"
                                                                  placeholder="name@company.com"
                                                                  required
                                                                  value={formData.email}
                                                                  onChange={handleChange}
                                                            />
                                                      </div>

                                                      {/* Password Field */}
                                                      <div className="relative mb-4">
                                                            <label className="block mb-2 text-sm font-medium text-gray-900">
                                                                  Password
                                                            </label>
                                                            <input
                                                                  type={showPassword ? "text" : "password"}
                                                                  name="password"
                                                                  className="border border-gray-200 text-gray-900 rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full py-2 px-4 pr-10"
                                                                  placeholder="••••••••"
                                                                  required
                                                                  value={formData.password}
                                                                  onChange={handleChange}
                                                            />
                                                            <span
                                                                  className="absolute right-3 top-[38px] text-gray-500 cursor-pointer"
                                                                  onClick={() => setShowPassword(!showPassword)}
                                                            >
                                                                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                            </span>
                                                      </div>

                                                      {/* Confirm Password Field */}
                                                      <div className="relative mb-4">
                                                            <label className="block mb-2 text-sm font-medium text-gray-900">
                                                                  Confirm Password
                                                            </label>
                                                            <input
                                                                  type={showConfirmPassword ? "text" : "password"}
                                                                  name="password_confirmation"
                                                                  className="border border-gray-200 text-gray-900 rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full py-2 px-4 pr-10"
                                                                  placeholder="••••••••"
                                                                  required
                                                                  value={formData.password_confirmation}
                                                                  onChange={handleChange}
                                                            />
                                                            <span
                                                                  className="absolute right-3 top-[38px] text-gray-500 cursor-pointer"
                                                                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                            >
                                                                  {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                                                            </span>
                                                      </div>

                                                      <div className="flex items-center justify-between">
                                                           <label className="flex items-start gap-2 text-sm text-gray-700">
                                                            <input
                                                                  type="checkbox"
                                                                  name="term"
                                                                  className="w-4 h-4 border border-gray-300 rounded"
                                                                  checked={termsChecked}
                                                                  onChange={(e) => handleCheckboxChange("terms", e.target.checked)}
                                                                  required
                                                                  value={formData.term}
                                                            />
                                                            <span>
                                                                  I accept the{" "}
                                                                  <Link
                                                                        to="/privacy-policy"
                                                                        className="text-blue-600 underline hover:text-blue-800"
                                                                        target="_blank"
                                                                  >
                                                                        Terms & Policies
                                                                  </Link>
                                                            </span>
                                                            </label> 
                                                      </div>


                                                      <div className="flex items-center justify-between">
                                                           <label className="flex items-start gap-2 text-sm text-gray-700">
                                                            <input
                                                                  type="checkbox"
                                                                  name="agreement"
                                                                  className="w-4 h-4 border border-gray-300 rounded"
                                                                  checked={agreementChecked}
                                                                  onChange={(e) => handleCheckboxChange("agreement", e.target.checked)}
                                                                  required
                                                                  value={formData.agreement}
                                                            />
                                                            <span>
                                                                  I accept the{" "}
                                                                  <Link
                                                                        to="/agreement"
                                                                        className="text-blue-600 underline hover:text-blue-800"
                                                                         target="_blank"
                                                                        
                                                                  >
                                                                        Passport Account Agreement
                                                                  </Link>
                                                            </span>
                                                            </label> 
                                                      </div>

                                                      

                                                      {/* Submit Button */}
                                                      {/* <button
                                                            type="submit"
                                                            className="w-full text-white bg-blue-500 hover:bg-blue-600 focus:ring-2 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center"
                                                            disabled={loading}
                                                      >
                                                            {loading ? "Signing up..." : "Sign up"}
                                                      </button> */}
                                                      {error && <div className="text-red-500 text-sm font-medium">{error}</div>}

                                                     <button
                                                      type="submit"
                                                      className="w-full text-white bg-blue-500 hover:bg-blue-600 focus:ring-2 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center disabled:bg-blue-300 disabled:cursor-not-allowed disabled:opacity-70"
                                                      disabled={!termsChecked || !agreementChecked || loading}
                                                      >
                                                      {loading ? "Signing up..." : "Sign up"}
                                                      </button>


                                                      {/* Login Link */}
                                                      <p className="text-sm text-center text-gray-500">
                                                            Already have an account?{" "}
                                                            <Link to="/login" className="font-medium text-blue-500 hover:underline">
                                                                  Sign in
                                                            </Link>
                                                      </p>
                                                </form>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </section>
                  <Footer />
            </>
      );
};

export default SignUp;
